module.exports = __webpack_public_path__ + "a7be67b34e8a115a15cf047c825c75b4.png";